module.exports = "\r\n<div class=\"welcomeWrapper\">\r\n<h1 class=\"goalTitle\">Piotr Troc </h1>\r\n<h1 class=\"goalTitle2\">CNC Simulator </h1>\r\n\r\n<h2 class=\"secondTitle\">\r\n  <a class=\"goalLink\" routerLink=\"/start\" routerLinkActive=\"active\">HAAS machine</a>\r\n</h2>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/WelcomeView/welcome.component.html
// module id = ./src/app/StartApp/welcome/WelcomeView/welcome.component.html
// module chunks = main